import * as React from 'react'

function IconTask(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={248}
      height={248}
      viewBox="0 0 248 248"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M123.53 247.06c68.224 0 123.53-55.306 123.53-123.53S191.754 0 123.53 0 0 55.306 0 123.53s55.306 123.53 123.53 123.53z"
        fill="#219321"
      />
      <path
        d="M119.4 27.67c-1.81.68-3.79.76-5.63.16-8.7-2.84-36.29-8.71-54.25 23.14-17.83 31.62-14.31 79.9-22.83 110.61-2.88 10.37 2.58 21.24 12.68 24.98 33.02 12.25 100.81 30.45 154.41-.49 7.35-4.24 11.23-12.67 9.89-21.05-6.54-40.89-31.32-160.95-94.27-137.35z"
        fill="#F4BA27"
      />
      <path
        d="M207.55 127.49c.61 9.05-6.31 17.17-15.35 17.98-.47.04-.93.06-1.4.07-4.28.04-8.17 2.46-9.93 6.36-10.5 23.26-32.92 36.15-55.9 37.6-23.25.79-47.06-10.08-59.67-32.67-1.87-3.35-5.61-5.26-9.41-4.76-.29.04-.59.07-.88.09-9.01.71-17.19-6.03-18.16-15.01-1.05-9.77 6.33-18.26 15.99-18.73h.03c1.77-.08 3.21-1.46 3.24-3.23.8-48.52 30.56-74.63 61.52-76.37 30.94-1.28 63.08 21.78 68.63 69.92.2 1.78 1.76 3.08 3.55 3h.03c9.22-.44 17.08 6.57 17.71 15.75z"
        fill="#fff"
      />
      <path
        d="M184.72 126.73a1.202 1.202 0 01-.88-2.08c.26-.24 6.44-5.89 17.42-3.9.65.12 1.09.75.97 1.4-.12.66-.75 1.09-1.4.97-9.74-1.76-15.12 3.08-15.35 3.29-.21.21-.48.31-.76.32z"
        fill="#000"
      />
      <path
        d="M199.54 129.18c-.38.02-.77-.15-1.02-.47-3.55-4.65-8.44-4.84-8.64-4.85-.66-.02-1.19-.57-1.17-1.23.02-.66.56-1.19 1.23-1.17.25.01 6.22.2 10.5 5.8.4.53.3 1.28-.23 1.69-.2.13-.43.21-.67.23zM61.12 132.76c-.27.01-.55-.07-.79-.25-.25-.19-6.08-4.48-15.6-1.78a1.2 1.2 0 01-1.49-.83c-.18-.64.19-1.31.83-1.49 10.74-3.05 17.44 1.97 17.72 2.18.53.41.63 1.16.22 1.69-.22.31-.55.47-.89.48z"
        fill="#000"
      />
      <path
        d="M46.61 136.63c-.24.01-.48-.05-.69-.18-.57-.35-.74-1.09-.39-1.66 3.71-5.99 9.64-6.76 9.89-6.79.66-.09 1.26.39 1.34 1.05.08.66-.39 1.26-1.05 1.34-.21.03-5.05.7-8.13 5.67-.22.35-.59.55-.97.57zM124.73 142.01c-.43.02-.86-.19-1.09-.59-.34-.57-.15-1.31.42-1.65 3.39-2.02 5.2-3.73 5.38-5.06.16-1.22-1.12-2.55-2.6-4.09-.9-.93-1.91-1.99-2.78-3.2-3.89-5.45-3.28-26.79-3.2-29.21.02-.67.58-1.17 1.24-1.16.67.02 1.19.58 1.16 1.24-.21 6.34-.13 23.67 2.76 27.73.76 1.07 1.67 2.01 2.55 2.93 1.83 1.91 3.57 3.71 3.25 6.08-.29 2.19-2.31 4.29-6.53 6.81-.18.1-.37.16-.56.17zM155.781 128.721c1.887-.092 3.285-2.859 3.123-6.179-.162-3.321-1.823-5.938-3.709-5.846-1.887.091-3.285 2.858-3.123 6.179.162 3.321 1.822 5.938 3.709 5.846zM92.682 131.801c1.886-.092 3.285-2.858 3.123-6.179-.162-3.321-1.823-5.938-3.71-5.846-1.886.092-3.284 2.858-3.122 6.179.162 3.321 1.822 5.938 3.709 5.846z"
        fill="#000"
      />
      <path
        d="M162.188 148.633c7-3.15 11.141-9.112 9.249-13.318-1.892-4.205-9.101-5.061-16.101-1.911-7.001 3.15-11.142 9.112-9.25 13.318 1.892 4.205 9.101 5.061 16.102 1.911zM103.862 148.791c1.474-4.37-3.227-9.901-10.501-12.356-7.274-2.454-14.366-.901-15.84 3.468-1.474 4.37 3.227 9.901 10.5 12.356 7.275 2.454 14.366.901 15.841-3.468z"
        fill="#FFDEDE"
      />
      <path
        d="M46.82 101.92c65.5-2.73 75.99-30.29 75.99-30.29s19.97 15.42 63.5 21.1l-12.58-42.35-47.11-19.75-51.24 13.52-28.56 57.77z"
        fill="#F4BA27"
      />
      <path
        d="M78.98 112.08a1.2 1.2 0 01-1.14-1.73c.08-.16 7.81-15.5 24.11-12.28.65.13 1.08.76.95 1.42-.13.65-.77 1.07-1.41.95-14.47-2.86-21.2 10.41-21.48 10.98-.21.39-.6.64-1.03.66zM168.25 107.12c-.42.02-.84-.18-1.08-.57-.33-.54-8.33-13.1-22.45-8.84-.64.19-1.31-.17-1.5-.81-.19-.64.17-1.31.81-1.5 15.92-4.79 25.1 9.73 25.19 9.88.35.57.17 1.31-.39 1.66-.18.12-.38.17-.58.18zM115.4 154.63c0-5.25 4.27-9.52 9.53-9.52 5.25 0 9.52 4.27 9.52 9.52s-4.27 9.53-9.52 9.53c-5.25-.01-9.53-4.28-9.53-9.53zm2.23 0c0 4.02 3.27 7.3 7.3 7.3 4.02 0 7.3-3.27 7.3-7.3 0-4.03-3.27-7.3-7.3-7.3-4.03 0-7.3 3.27-7.3 7.3z"
        fill="#000"
      />
    </svg>
  )
}

export default IconTask
